
import { Vue } from 'vue-class-component'
import { Formater } from '@/utils/formater'
import { get } from 'lodash'

export default class OverviewCardMixin extends Vue {
  totalActiveUsers = 0
  totalBlockedUsers = 0
  totalTodayNewUsers = 0
  totalTodayBlockedUsers = 0
  totalYesterdayActiveUsers = 0
  totalYesterdayBlockedUsers = 0
  totalPopupClickUsers = 0
  popupClickRate = 0
  totalPopupClick = 0
  totalInitialMessages = 0
  totalPushMessages = 0
  totalChatResponses = 0
  totalStandardResponses = 0
  totalUsageMessages = 0
  totalCurrentPlan = 0

  //  remaining messages card
  get remainingMessages() {
    return this.totalCurrentPlan - this.totalUsageMessages
  }

  get remainingProgressValue() {
    if (this.totalCurrentPlan === 0) return 0
    return this.remainingMessages / this.totalCurrentPlan
  }

  get remainingInfo() {
    return [
      {
        label: this.$t('label.usage'),
        value: `${this.numberWithCommas(this.totalUsageMessages)}通`,
        valueClass: 'text-negative',
      },
      {
        label: this.$t('label.limit_on_current_plan'),
        value: `${this.numberWithCommas(this.totalCurrentPlan)}通`,
        valueClass: '',
      },
    ]
  }

  //  active users card
  get diffActiveUsers() {
    let diff = this.totalTodayNewUsers - this.totalTodayBlockedUsers
    if (diff < 0) {
      diff = diff * -1
    }
    return diff
  }

  get isMinusActiveUsers() {
    const diff = this.totalTodayNewUsers - this.totalTodayBlockedUsers
    if (diff < 0) {
      return true
    }
    return false
  }

  get activeUsersInfo() {
    return [
      {
        label: this.$t('label.total_active_users'),
        value: `${this.numberWithCommas(this.totalActiveUsers)}人`,
        valueClass: '',
      },
      {
        label: this.$t('label.today_new_users'),
        value: `${this.numberWithCommas(this.totalTodayNewUsers)}人`,
        valueClass: 'text-positive',
      },
      {
        label: this.$t('label.today_block_users'),
        value: `${this.numberWithCommas(this.totalTodayBlockedUsers)}人`,
        valueClass: 'text-negative',
      },
    ]
  }

  //  blocked users card
  get diffBlockedUsers() {
    let diff = 0
    const lastDay = this.totalYesterdayActiveUsers + this.totalYesterdayBlockedUsers
    if (lastDay !== 0) {
      diff = this.totalYesterdayBlockedUsers / lastDay
    }
    return this.roundNumber(diff * 100)
  }

  get isMinusBlockedUsers() {
    let diff = 0
    const lastDay = this.totalYesterdayActiveUsers + this.totalYesterdayBlockedUsers
    if (lastDay !== 0) {
      diff = this.totalYesterdayBlockedUsers / lastDay
    }
    if (diff === 0) {
      return true
    }
    return false
  }

  get blockedRate() {
    let rate = 0
    if (this.totalActiveUsers !== 0) {
      rate = (this.totalBlockedUsers / this.totalActiveUsers) * 100
    }
    return this.roundNumber(rate)
  }

  get blockedUsersInfo() {
    return [
      {
        label: this.$t('label.blocked_rate'),
        value: `${this.blockedRate} %`,
        valueClass: '',
      },
      {
        label: this.$t('label.total_blocks'),
        value: `${this.numberWithCommas(this.totalBlockedUsers)} / ${this.numberWithCommas(
          this.totalBlockedUsers + this.totalActiveUsers
        )}人`,
        valueClass: '',
      },
    ]
  }

  get popupClickInfo() {
    return [
      {
        label: this.$t('label.clicked_rate'),
        value: `${this.popupClickRate}%`,
      },
      {
        label: this.$t('label.click_user'),
        value: `${this.numberWithCommas(this.totalPopupClickUsers)}人`,
      },
    ]
  }

  get storyDeliveries() {
    return this.numberWithCommas(this.totalInitialMessages + this.totalPushMessages)
  }

  get storyDeliveriesInfo() {
    return [
      {
        label: this.$t('label.initial_message'),
        value: `${this.numberWithCommas(this.totalInitialMessages)}通`,
      },
      {
        label: this.$t('label.push_messages'),
        value: `${this.numberWithCommas(this.totalPushMessages)}通`,
      },
    ]
  }

  //  form responses card
  get formResponses() {
    return this.numberWithCommas(this.totalChatResponses + this.totalStandardResponses)
  }

  get formResponsesInfo() {
    return [
      {
        label: this.$t('label.chat_format'),
        value: `${this.numberWithCommas(this.totalChatResponses)}回`,
      },
      {
        label: this.$t('label.form_format'),
        value: `${this.numberWithCommas(this.totalStandardResponses)}回`,
      },
    ]
  }

  //  utility methods
  numberWithCommas(num: number) {
    return Formater.numberFormat(num)
  }

  roundNumber(num: number) {
    return Formater.round(num)
  }

  resetCardData() {
    this.totalActiveUsers = 0
    this.totalBlockedUsers = 0
    this.totalTodayNewUsers = 0
    this.totalTodayBlockedUsers = 0
    this.totalYesterdayActiveUsers = 0
    this.totalYesterdayBlockedUsers = 0
    this.totalPopupClickUsers = 0
    this.popupClickRate = 0
    this.totalPopupClick = 0
    this.totalInitialMessages = 0
    this.totalPushMessages = 0
    this.totalChatResponses = 0
    this.totalStandardResponses = 0
    this.totalUsageMessages = 0
    this.totalCurrentPlan = 0
  }

  updateCardData(resp: any) {
    this.totalActiveUsers = get(resp, 'total_active_users', 0)
    this.totalBlockedUsers = get(resp, 'total_blocked_users', 0)
    this.totalTodayNewUsers = get(resp, 'total_today_new_users', 0)
    this.totalTodayBlockedUsers = get(resp, 'total_today_blocked_users', 0)
    this.totalYesterdayActiveUsers = get(resp, 'total_yesterday_active_users', 0)
    this.totalYesterdayBlockedUsers = get(resp, 'total_yesterday_blocked_users', 0)
    this.totalPopupClickUsers = get(resp, 'popup.click_users', 0)
    this.popupClickRate = get(resp, 'popup.click_rate', 0)
    this.totalPopupClick = get(resp, 'popup.total_click', 0)
    this.totalInitialMessages = get(resp, 'story.total_initial_messages', 0)
    this.totalPushMessages = get(resp, 'story.total_push_messages', 0)
    this.totalChatResponses = get(resp, 'form.total_chat_messages', 0)
    this.totalStandardResponses = get(resp, 'form.total_standard_messages', 0)
    this.totalUsageMessages = get(resp, 'total_usage_messages', 0)
    this.totalCurrentPlan = get(resp, 'total_current_plan', 0)
  }
}
